import { render, staticRenderFns } from "./SelectBankAccountType.vue?vue&type=template&id=467ed0a4"
import script from "./SelectBankAccountType.vue?vue&type=script&lang=js"
export * from "./SelectBankAccountType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports